import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation createCallsheets($input: CallsheetInputs!) {
    createCallsheets(input: $input) {
      ...callsheetDetail
    }
  }
  ${fragments.callsheetDetail}
  ${fragments.artworkDetails}
  ${fragments.artworkArtifact}
`;
